export const ParentSizeMixin = {
  data() {
    return {
      parentWidth: 0,
      parentHeight: 0,
    };
  },
  methods: {
    setSize([width, height]) {
      this.parentWidth = width;
      this.parentHeight = height;
    },
  },
};
